import { Directive, OnInit, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[otscInit]',
  standalone: true
})
export class OtscInitDirective implements OnInit{
  @Output() otscInit: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.otscInit.emit();
  }

}
